import React, { useState } from 'react';
import '../styles/message.css';
import Box from './Box';
import Modal from 'antd/es/modal';
import { useContext } from 'react';
import { DownOutlined } from '@ant-design/icons';
import { BsCheck } from 'react-icons/bs';
import { BsCheckAll } from 'react-icons/bs';
import filterContext from '../context/filters/filterContext';
// import { log } from 'winston';
import { Checkbox } from 'antd';
import moment from 'moment';

const apiBaseUrl = process.env.REACT_APP_API_BASE_URL;
function MsgPolls({
	que,
	opt,
	msgId,
	votes,
	sender,
	senderId,
	senderName,
	prevId,
	isRedFlag,
	readBy,
	create,
	time,
	prevTime,
}) {
	// votes.map(vote => {
	// 	console.log(vote.selectedOption);
	// });
	// console.log(votes);
	const {
		usersOfParticularGroup,
		forwardCheckbox,
		setForwardCheckbox,
		selectedMsgs,
		setSelectedMsgs,
		selectedReceivedMsgs,
		setSelectedReceivedMsgs,
		isPollMsgSelected,
		setIsPollMsgSelected,
		fetchConversation,
	} = useContext(filterContext);
	const [visible, setVisible] = useState(false);
	const [showDropdown, setShowDropdown] = useState(false);
	const [showInfoModal, setShowInfoModal] = useState(false);
	const [deliveryStatusData, setDeliveryStatusData] = useState([]);
	const [nameOfVoters, setnameOfVoters] = useState(['name1', 'name2']);
	const [showDeliveryStatusModal, setShowDeliveryStatusModal] = useState(false);
	const [remarkInput, setRemarkInput] = useState('');
	const showModal = () => {
		setVisible(true);
		console.log(usersOfParticularGroup);
		// usersOfParticularGroup.map((user, i) => {
		// 	console.log(user.user.name);
		// });
	};
	const [isRedFlagged, setIsRedFlagged] = useState(isRedFlag);

	const handleOk = () => {
		setVisible(false);
	};

	const handleCancel = () => {
		setVisible(false);
	};

	const handleCaretClick = event => {
		event.stopPropagation();
		setShowDropdown(true);
	};

	const handleDropdownBlur = () => {
		setShowDropdown(false);
	};

	const toggleInfoModal = () => {
		if (showInfoModal) {
			// If the modal is already open, close it
			setShowInfoModal(false);
		} else {
			// Fetch delivery status data from the server
			fetchDeliveryStatusData();
		}
	};

	const fetchDeliveryStatusData = () => {
		// Make an API call to get the delivery status data
		console.log('Calledx');
		fetch(`${apiBaseUrl}/chats/getDeliveryStatus?messageId=${msgId}`, {
			method: 'GET',
			headers: {
				'Content-Type': 'application/json',
				authorization: `Token ${window.localStorage.getItem('token')}`,
			},
		})
			.then(response => response.json())
			.then(data => {
				if (data.success) {
					// Set the delivery status data in the state
					setDeliveryStatusData(data.deliveredStatus);
					// Show the modal
					setShowInfoModal(true);
				} else {
					console.error('Error fetching delivery status data:', data.error);
				}
			})
			.catch(error => {
				console.error('Error fetching delivery status data:', error);
			});
	};
	const handleMsgSelect = (userId, isSender) => {
		console.log(isSender);
		if (selectedMsgs.includes(userId)) {
			setSelectedMsgs(selectedMsgs.filter(id => id !== userId));
			setSelectedReceivedMsgs(selectedReceivedMsgs.filter(id => id !== userId));
			setIsPollMsgSelected(isPollMsgSelected.filter(id => id !== userId));
		} else {
			setSelectedMsgs([...selectedMsgs, userId]);
			setIsPollMsgSelected([...isPollMsgSelected, userId]);
			if (isSender == false) {
				setSelectedReceivedMsgs([...selectedReceivedMsgs, userId]);
			}
		}
	};

	const markAsRedFlag = () => {
		// If the message is already red-flagged, show the delivery status modal
		if (isRedFlagged) {
			setShowDeliveryStatusModal(true);
		} else {
			// For marking as Red Flag, clear the remarkInput state
			setRemarkInput('');

			const requestBody = { id: msgId, remark: '' };

			fetch(`${apiBaseUrl}/chats/toggleMessageRedFlag`, {
				method: 'POST',
				body: JSON.stringify(requestBody),
				headers: {
					'Content-Type': 'application/json',
					authorization: `Token ${window.localStorage.getItem('token')}`,
				},
			})
				.then(response => response.json())
				.then(data => {
					if (data.success) {
						setIsRedFlagged(true);
						fetchConversation();
					} else {
						console.error('Error marking message as red flag:', data.error);
					}
				})
				.catch(error => {
					console.error('Error marking message as red flag:', error);
				});
		}
	};

	const getUserName = userId => {
		const user = usersOfParticularGroup.find(user => user.user._id === userId);
		if (user) {
			return user.user.name;
		}
		return '';
	};

	const formatMessageTime = time => {
		// You can customize the time format as per your requirement
		return moment(create)
			.locale('en-in')
			.format('h:mm A');
	};

	const messageDate = () => {
		const currentDate = moment();
		const yesterdayDate = moment().subtract(1, 'day');
		if (moment(create).isSame(currentDate, 'day')) {
			return 'Today';
		} else if (moment(create).isSame(yesterdayDate, 'day')) {
			return 'Yesterday';
		} else {
			return moment(create).format('DD/MM/YYYY');
		}
	};

	return (
		<div>
			{moment(prevTime).isSame(moment(create), 'day') == false && (
				<p className="msg-date-info">{messageDate()}</p>
			)}

			<div style={{ display: 'flex' }}>
				{forwardCheckbox === true && (
					<div
						style={{
							display: 'flex',
							alignItems: 'center',
							marginRight: '2.5rem',
							marginLeft: '1rem',
						}}
					>
						{/* <Checkbox
						checked={selectedMsgs.includes(msgId)}
						onChange={() => handleMsgSelect(msgId, sender)}
						className="rounded-checkbox"
						style={{ height: '15px', width: '15px', marginRight: '2.5rem' }}
					/> */}
					</div>
				)}
				<div
					style={{
						paddingLeft: `${senderId == prevId ? '2.5rem' : '0'}`,
						display: 'flex',
					}}
				>
					{usersOfParticularGroup.map(user => {
						// console.log(msg,senderId,prevId)
						if (user.user._id == senderId && sender == false && senderId != prevId) {
							return (
								<img
									src={
										user.user.dp === ''
											? 'https://s3.ap-south-1.amazonaws.com/avatars.prepleaf.com/u/6471ec801d1a71103fc8f669/UKVqGegFg8.svg'
											: user.user.dp
									}
									alt=""
									style={{
										height: '30px',
										width: '30px',
										borderRadius: '50%',
										backgroundColor: 'white',
										marginRight: '10px',
										marginTop: `${senderId != prevId ? '10px' : '3px'}`,
									}}
								/>
							);
						}
					})}
				</div>
				<Modal
					title="Votes"
					visible={visible}
					onOk={handleOk}
					onCancel={handleCancel}
					footer={null}
				>
					{votes.map(vote => {
						const user = usersOfParticularGroup.find(
							user => user.user._id === vote.userId
						);
						if (user) {
							return (
								<h5 key={vote.userId}>
									{user.user.name} : {vote.selectedOption}
								</h5>
							);
						}
						return null;
					})}
				</Modal>
				<div
					className={`message-container ${
						!sender ? 'received-msg' : 'sent-msg'
					} img-msg ${isRedFlagged ? 'red-flag' : ''}`}
					onMouseEnter={() => setShowDropdown(false)}
					onMouseLeave={() => setShowDropdown(false)}
					style={{ marginTop: `${senderId != prevId ? '10px' : '3px'}` }}
				>
					<div className="normal-msg">
						<div style={{ padding: '5px' }}>
							{senderId != prevId && sender == false && (
								<b
									style={{
										color: '#7381FF',
										marginTop: '0',
										// paddingLeft: `${media ? '13px' : '8px'}`,
										paddingRight: '30px',
										alignSelf: 'flex-start',
									}}
								>
									{senderName}
								</b>
							)}

							<div style={{ color: 'white', padding: '8px' }}>
								<h5> {que}</h5>
							</div>
							<div>
								{opt.map((option, index) => {
									return (
										<Box
											key={index}
											option={option}
											msgId={msgId}
											indopt={opt}
											votes={votes}
											votecount={
												votes.filter(voteItem => voteItem.selectedOption === option).length
											}
											oidx={index}
										/>
									);
								})}
							</div>

							{/* {showDropdown || forwardCheckbox ? null : (
							<div
								className="caret"
								onClick={handleCaretClick}
								style={{ lineHeight: '5px', cursor: 'pointer', fontSize: '10px' }}
							>
								<DownOutlined />
							</div>
						)} */}
						</div>
					</div>

					<p style={{ color: 'white', cursor: 'pointer' }} onClick={showModal}>
						View Vote
					</p>
					<div
						className="normal-msg"
						style={{
							display: 'flex',
							justifyContent: 'space-between',
							alignItems: 'flex-end',
						}}
					>
						<div className="poll-tools">
							<p className="msg-time">{formatMessageTime(time)}</p>

							{/* {renderFlagTooltip()} */}

							{/* {sender ? (
								<p className="msg-time tickmark">{renderTickMark()}</p>
							) : (
								<p className="msg-time tickmark"></p>
							)} */}
						</div>
					</div>
					{showDropdown && (
						<div
							className={`dropdown ${sender ? 'dropdown-left' : 'dropdown-right'}`}
							onBlur={handleDropdownBlur}
						>
							<ul>
								<li onClick={markAsRedFlag}>
									{isRedFlagged ? 'Remove Red Flag' : 'Mark as Red Flag'}
								</li>
								<li
									onClick={() => {
										setForwardCheckbox(true);
										handleMsgSelect(msgId, sender);
										setShowDropdown(false);
									}}
								>
									Select
								</li>
								{/* <li onClick={markAsDelete}>Delete For Me</li> */}
								{/* {sender && <li onClick={markAsUnsend}>Delete For Everyone</li>} */}
								{sender && <li onClick={toggleInfoModal}>Show Info</li>}
							</ul>
						</div>
					)}
				</div>

				<Modal
					open={showInfoModal}
					onCancel={() => setShowInfoModal(false)}
					footer={null}
					closable={false}
					className="delivery-status-modal"
					centered
				>
					<h2>Delivery Status</h2>

					{/* Display Read By Users */}
					<div className="status-group">
						<h3>Read By</h3>
						{readBy && readBy.length > 0 ? (
							readBy.map((userId, index) => (
								<div key={index} className="status-item">
									{/* {usersOfParticularGroup.map((user) => {
									
								})} */}
									<p>{getUserName(userId)}</p> {/* Show the user name */}
									<p className="status-icon">
										<BsCheckAll /> {/* You can change the icon based on the status */}
									</p>
								</div>
							))
						) : (
							<p>No users have read the message yet.</p>
						)}
					</div>

					{/* Display Delivered Status Users */}
					<div className="status-group">
						<h3>Delivered Status</h3>
						{deliveryStatusData
							.filter(status => status.status === 'delivered')
							.filter(status => !readBy.includes(status.user._id)) // Filter out users already in Read By
							.map((status, index) => (
								<div key={index} className="status-item">
									<div className="status-details">
										<p className="status-name">{status.user.name}</p>
										<p className="status-icon">
											<BsCheckAll /> {/* You can change the icon based on the status */}
										</p>
									</div>
								</div>
							))}
						{deliveryStatusData.filter(
							status =>
								status.status === 'delivered' && !readBy.includes(status.user._id)
						).length === 0 &&
							!readBy.length && <p>No users have received the message yet.</p>}
						{deliveryStatusData.filter(
							status =>
								status.status === 'delivered' && !readBy.includes(status.user._id)
						).length === 0 &&
							readBy.length && <p>All users have received the message.</p>}
					</div>

					{/* Display Not Delivered Users */}
					<div className="status-group">
						<h3>Not Delivered</h3>
						{deliveryStatusData
							.filter(status => status.status === 'pending')
							.map((status, index) => (
								<div key={index} className="status-item">
									<p>{status.user.name}</p>
									<p className="status-icon">
										<BsCheck /> {/* You can change the icon based on the status */}
									</p>
								</div>
							))}
						{deliveryStatusData.filter(status => status.status === 'pending')
							.length === 0 && <p>All users have received the message.</p>}
					</div>
				</Modal>
			</div>
		</div>
	);
}

export default MsgPolls;
